export const mrfZipGroups = {
  '5565362232': ['KISA', 'OSKARSHAMN', 'VIMMERBY', 'VÄSTERVIK', 'HÖGSBY'],
  '5564463221': ['HANDEN', 'MALMÖ'],
  '5560624446': ['LILLA EDET', 'STENUNGSUND'],

  '5560554106': ['VÄXJÖ', 'ÄLMHULT', 'LAHOLM'],
  '5567482608': ['ÅKERSBERGA'],
  '5564982311': ['LINKÖPING', 'MOTALA', 'MJÖLBY', 'NYKÖPING', 'NORRKÖPING'],
  '5560626839': ['Växjö', '', '', 'Borås'],
  '5562104124': ['Tranås', 'LJUNGBY', 'ÄLMHULT', 'LESSEBO', 'Jönköping', 'Växsjö', 'Nässjö'],
  '5560926643': ['OSKARSHAMN'],
  '5560614298': ['VETLANDA', 'OSKARSHAMN'],
  '5566925763': ['Linköping', 'Norrköping'],
  '5560266008': ['ÖSTERSUND', 'Sollefteå'],
  '5566480983': ['SUNDSBRUK', 'ÖSTERSUND'],
  '5563292118': ['FALUN', 'LUDVIKA', 'AVESTA', 'BORLÄNGE', 'VÄSTERÅS', ''],
  '5569999351': ['Karlshamn', 'KALMAR', 'Ystad', 'Vetlanda'],
  '5560525692': ['ÖRNSKÖLDSVIK', 'ÖSTERSUND', 'HÄRNÖSAND', 'SKELLEFTEÅ', 'UMEÅ', 'LULEÅ', 'SOLLEFTEÅ', 'STRÖMSUND', 'LYCKSELE'],
  '5564650488': ['BOLLNÄS', 'HUDIKSVALL', 'LJUSDAL', 'SÖDERHAMN'],
  '5560098385': ['NORRTÄLJE', 'ÖSTHAMMAR'],
  '5563153880': ['SUNDSVALL', 'TIMRÅ'],
  '5560465659': ['KUNGENS KURVA', 'UDDEVALLA', 'MÖLNDAL', 'NACKA', 'BORÅS', 'TROLLHÄTTAN', 'KUNGSBACKA'],
  '5590823851': ['KISTA', 'SKOGÅS', 'SOLNA', 'SKELLEFTEÅ', '', 'DANDERYD', 'SÖDERTÄLJE', 'NYKÖPING'],
  '5566560925': ['KUNGENS KURVA', 'HANINGE', 'SALTSJÖ BOO', 'SÖDERTÄLJE', 'MALMÖ', 'VÄSTERÅS', 'BORLÄNGE', 'FALUN', 'ENKÖPING'],
  '5560631086': [
    'ESKILSTUNA',
    'STRÄNGNÄS',
    'VÄSTERÅS',
    'KÖPING',
    'ENKÖPING',
    'SOLNA',
    'NACKA',
    'BROMMA',
    'HANINGE',
    'SEGELTORP',
    'TÄBY',
    'VÄLLINGBY',
    'TYRESÖ',
    'TUMBA',
    'JÄRFÄLLA',
    'LIDINGÖ',
    'Stockholm',
    'MALMÖ',
    'LUND',
    'TRELLEBORG',
    'GÖTEBORG',
    'KUNGSBACKA',
    'KUNGÄLV',
    'STENKULLEN',
  ],
  '5561509224': ['NORRKÖPING', 'NYKÖPING'],
  '5565265385': ['SKELLEFTEÅ', 'UMEÅ', 'LULEÅ', 'PITEÅ', 'ÖRNSKÖLDSVIK', 'Gävle'],
  '5567735021': ['KALMAR', 'KARLSKRONA', 'OSKARSHAMN'],
  '5560403650': ['MORA', 'LEKSAND', 'MALUNG'],
  '5567359491': ['GÄVLE', 'FALUN'],
  '5562567965': ['HÖRBY', 'KRISTIANSTAD', 'ESLÖV', 'ÄNGELHOLM', 'SIMRISHAMN', 'SJÖBO', 'KLIPPAN', 'LUND', 'YSTAD'],
  '5562011485': ['LYCKSELE', 'ÖRNSKÖLDSVIK'],
  '5560707183': ['BORÅS', 'KINNA', 'TRANEMO', 'ULRICEHAMN'],
  '5563769123': ['VÄNERSBORG', 'UDDEVALLA'],
  '5593735029': ['HEDEMORA', 'MORA', 'FALUN'],
  '5560562166': ['Alingsås', 'STRÖMSTAD', 'SKÖVDE', 'BENGTSFORS', 'TROLLHÄTTAN', 'MARIESTAD', 'SKARA', 'SÄFFLE', 'ED', 'LYSEKIL', 'MELLERUD'],
  '5561080085': ['LIDKÖPING', 'VARA'],
  '5565488920': ['ÅKERSBERGA', 'NORRTÄLJE'],
  '5561928986': ['KARLSHAMN', 'KARLSKRONA', 'RONNEBY', 'ÄNGELHOLM', 'ALINGSÅS', 'KLIPPAN'],
  '5563841120': ['KRISTIANSTAD', 'ÖSTRA LJUNGBY'],
  '5560624032': ['ÖRNSKÖLDSVIK', 'UMEÅ'],
  '5560605791': ['STOCKHOLM', 'MALMÖ', 'GÖTEBORG', 'MORA', 'GUSTAVSBERG', 'NORSBORG', 'UPPLANDS VÄSBY', 'LANDSKRONA'],
  '5560760836': ['LINKÖPING', 'Västervik'],
  '5565601837': ['VÄSTERVIK', 'LINKÖPING', 'VIMMERBY', 'KISA'],
  '5569547853': ['LINKÖPING'],
  '5560087453': ['VÄRNAMO', 'GISLAVED', 'VARBERG'],
  '5560195546': ['KRISTIANSTAD', 'LUND', 'MALMÖ', 'ÄNGELHOLM', 'HELSINGBORG'],
  '5561173518': ['SUNDBYBERG', 'MÄRSTA'],
  '5562092188': ['KISA', 'TRANÅS'],
  '5562689181': ['MARKARYD', 'ÄLMHULT', 'HÄSSLEHOLM', 'OSBY'],
  '5560328543': ['LUND', 'MALMÖ'],
  '5560575598': ['LJUNGBY', 'KARLSHAMN', 'SÖLVESBORG'],
  '5568975725': ['UPPLANDS VÄSBY', 'GÄVLE', 'VÄXJÖ'],
  '5565430070': ['LANDSKRONA', 'HELSINGBORG'],
  '5560704800': ['SÖLVESBORG', 'KRISTIANSTAD', 'HÄSSLEHOLM'],
  '5560629007': ['ARVIKA', 'KARLSTAD'],
  '5560505082': ['VÄXJÖ', 'KALMAR', 'NYBRO', 'TINGSRYD'],
  '5565556791': ['KÖPING'],
  '5560553561': ['BORÅS', 'SKÖVDE', 'FALKÖPING', 'ALINGSÅS', 'TROLLHÄTTAN', 'JÖNKÖPING'],
  '5562259142': ['TOMELILLA', 'YSTAD'],
  '5566918339': ['Sollentuna', 'Täby'],
  '5566864301': ['SKÄRHOLMEN', 'MALMÖ'],
  '5563466969': ['SKENE', 'MARIESTAD', 'LIDKÖPING', 'Skara', 'HALMSTAD', 'VARBERG', 'Karlstad', 'ARVIKA', 'KUNGSBACKA'],
  '5562987510': [
    'ENKÖPING',
    'UPPSALA',
    'Eskilstuna',
    'KATRINEHOLM',
    'STRÄNGNÄS',
    'ÖREBRO',
    'VÄSTERÅS',
    'KARLSKOGA',
    'KÖPING',
    'Sala',
    'LINDESBERG',
    'HISINGS BACKA',
  ],
  '5561111815': ['SKELLEFTEÅ', 'LULEÅ', 'LULEÅ', 'MALÅ', 'ARVIDSJAUR', 'KIRUNA'],
  '5567433924': ['SKELLEFTEÅ', 'MALÅ', 'LULEÅ', 'PITEÅ'],
  '5560559162': ['JÖNKÖPING', 'NÄSSJÖ', 'Habo'],
  '5568447956': ['JÄRFÄLLA', 'Kristianstad', 'VIMMERBY', 'Helsingborg', 'SKENE', 'VÄNERSBORG', 'Skövde', 'VÄSTERÅS', 'VETLANDA', 'JÖNKÖPING', 'BANDHAGEN'],
  '5560897810': ['HALMSTAD', 'LAHOLM', 'FALKENBERG'],
  '5560822305': ['HALMSTAD'],
  '5563462885': ['SÖDERTÄLJE'],
  '5565979209': ['FALUN', 'BORLÄNGE'],
  '5560514621': ['STOCKHOLM', 'HANDEN', 'HANDEN', 'STOCKHOLM', 'KUNGENS KURVA', 'Örebro', 'Västerås', 'GÖTEBORG'],
  '5560655689': ['KALMAR', 'KARLSKRONA'],
  '5561401992': ['MOTALA', 'TRANÅS', 'VETLANDA'],
  '5560639667': ['KATRINEHOLM', 'NYKÖPING', 'FLEN'],
  '5560542051': ['VÄXJÖ', 'KALMAR', 'VETLANDA'],
  '5560623331': ['KATRINEHOLM', 'NYKÖPING'],
  '5564253283': ['Värnamo', 'Gislaved', 'HALMSTAD'],
  '5560618596': ['LINKÖPING', 'LINKÖPING', 'MJÖLBY', 'ÅTVIDABERG', 'LINKÖPING'],
  '5560961228': ['HALLSBERG', 'ÖREBRO', 'ASKERSUND', 'LINDESBERG'],
  '5560682154': ['ÖREBRO', 'NYKÖPING', 'KATRINEHOLM'],
  '5561109090': ['GÄVLE', 'SÖDERHAMN'],
  '5565041455': ['VARBERG', 'BORÅS', 'FALKENBERG', 'KINNA', 'ULRICEHAMN', 'VARBERG'],
  '5561363366': ['VARA', 'UDDEVALLA', 'TROLLHÄTTAN', 'LIDKÖPING', 'MARIESTAD', 'LIDKÖPING'],
  '5560630740': ['SKEE', 'FALKÖPING', 'LIDKÖPING', 'STENUGNSUND'],
  '5563373025': ['MÖLNDAL', 'HISINGS BACKA'],
  '5567215362': ['KARLSTAD', 'ÖREBRO', 'VÄSTERÅS', 'KUNGENS KURVA'],
  '5560428715': ['Stockholm'],
  '5566276175': ['UPPLANDS VÄSBY', 'GÖTEBORG', 'ENKÖPING', 'SOLLENTUNA', 'VALLENTUNA', 'KUNGSÄNGEN', 'ENKÖPING', 'HISINGSBACKA'],
  '5560727777': ['SOLLENTUNA', 'HANINGE', 'SÖDERTÄLJE', 'HISINGS BACKA', 'STORA HÖGA', 'GÖTEBORG', 'MÖLNDAL'],
  '5561953877': ['KARLSTAD', 'KARLSTAD', 'KARLSTAD', 'ARVIKA'],
  '5560733114': [
    'DANDERYD',
    'SALTSJÖ BOO',
    'HÄGERSTEN',
    'HANDEN',
    'SÖDERTÄLJE',
    'HELSINGBORG',
    'VÄSTRA FRÖLUNDA',
    'HISINGS KÄRRA',
    'ÖREBRO',
    'NORRKÖPING',
    'SKÄRHOLMEN',
    'LINKÖPING',
    'MALMÖ',
    'DANDERYD',
    'KUNGÄLV',
  ],
  '5560789751': ['ÖRNSKÖLDSVIK', 'ÖSTERSUND', 'VÄSTERÅS', 'UPPSALA', 'GÄLLIVARE', 'ARLANDASTAD'],
} as const;
